<template>
<div>
  <!-- 分割线 -->
  <div class="cut_off"></div>
  <!-- 内容 -->
    <div class="platform_box">
    <!-- left -->
    <div class="platform_left">
       <login-function></login-function>
       <login-deal :list="list"></login-deal>
    </div>
    <!-- right -->
    <div class="platform_right">
      <!-- 1 -->
      <div class="release">
        <!--  -->
        <div class="money">
          帳戶餘額： <span>{{money}}元</span>
        </div>
        <div class="release_button">
        <!--  <button @click="goRouter('/login/deal/shift')">儲值</button> -->
          <button @click="goRouter('/login/deal/statement')">資金流水</button>
          <button @click="goRouter('/login/deal/rolloff')" class="active">提領</button>
        </div>
        <!--  -->
        <div class="release_contnet">
          <p v-for="item of releaseList" :key="item.id">
            {{item.id}}：{{item.val}}
          </p>
          <p>
            結算周期：<span class="cur_div" @click="goRouter('/login/account/loginbu')">點擊查看</span>
          </p>
        </div>
      </div>
      <!-- 2 -->
      <div class="notice">
        <h3 class="notice_title">平台公告</h3>
        <!--  -->
        <div class="notice_content">
          <p v-for="item of noticeList" :key="item.id">
            {{item}}
          </p>
          <div class="more" @click="noticeMoreFun()">查看更多>></div>
        </div>
      </div>
      <!-- 3 -->
      <div class="explain">
        <div class="explain_content">
          <!-- <p v-for="item of explainList" :key="item.id">
            {{item.content}}
          </p> -->
					<img src="@/assets/img/common/onersd.jpg" alt="" style="width: 100%">
        </div>
        <!-- <div class="more">查看更多>></div> -->
      </div>
      <!--  -->
    </div>
  </div>
  <!--  -->
</div>
</template>

<script>
import axios from 'axios';
import LoginFunction from '@/page/common/Function.vue';
import LoginDeal from '@/page/common/Deal.vue';

export default {
  name: 'platform',
  metaInfo: {
    title: '台易購-商家平台-首頁', // set a title
    meta: [{ // set meta
      name: 'keyWords',
      content: '台灣，購物中心，電子商務，電商平台'
    }, {
      name: 'Description',
      content: '台易購是一個電商平台。'
    }]
  },
  props: {
  },
  data() {
    return {
      currency: "NTD",
      money: 417,
      list: {},
      releaseList: [
        {
          id: "預留資訊",
          val: ""
        },
        {
          id: "商家簡稱",
          val: ""
        },
        {
          id: "公司全名",
          val: ""
        },
        {
          id: "行業項目",
          val: ""
        }
      ],
      noticeList: [
        // {
        //   id: "001",
        //   time: "01.18",
        //   content: "春節期間商審核通知"
        // }
      ],
      explainList: [
        {
          id: "001",
          content: "· 平台使用說明下載(20190221Ver.)"
        },
        {
          id: "002",
          content: "· 平台使用說明下載(20190231Ver.)"
        },
        {
          id: "003",
          content: "· 平台使用說明下載(20190331Ver.)"
        },
        {
          id: "004",
          content: "· 平台使用說明下載(20190421Ver.)"
        },
        {
          id: "005",
          content: "· 平台使用說明下載(20190521Ver.)"
        }
      ]
    }
  },
  components: {
    LoginFunction,
    LoginDeal
  },
  methods: {
    // FUN-全局-記錄-负责人姓名
    recordPrincipal(principal){
       this.$store.commit('changePrincipal',principal);
    },
    goRouter(index){
      this.$router.push(index);
    },
    noticeMoreFun(){
      this.$router.push('/login/notice');
    }
  },
  mounted(){
    axios.get(this.$store.state.axiosLoginUrl, {
            params: {
              action: 1,
              uid: this.$store.state.uid
            }
          }).then( res =>{
            // console.log(res.data);
            this.recordPrincipal(res.data.message[0]);
            this.money = res.data.message[0].money;
            this.releaseList = res.data.message[1];
            this.noticeList = res.data.message[2];
            this.list = res.data.message[3];
          })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.cur_div {
  cursor: pointer;
}
.cut_off {
  height: 4px;
  background: #e73262;
}
.platform_box {
    box-sizing: border-box;
    padding: 29px 34px;
    display: flex;
    font-size: 13px;
    width: 1260px;
    margin: 0 auto;
    color: #777777;
  }
  .platform_box .platform_left {
    margin-right: 49px;
    overflow: hidden;
    /* width: 70vw; */
  }
  .platform_box .platform_right {
    width: 340px;
    overflow: hidden;
  }
  .more {
    cursor: pointer;
    float: right;
    margin: 9px 0;
  }
.platform_right .release {
    /* 1 */
    overflow: hidden;
    border: 1px solid #999999;
    border-bottom: 10px solid #999999;
    padding: 22px;
  }
  .platform_right .release .money {
    letter-spacing: 1px;
  }
  .platform_right .release span {
    margin-left: 27px;
  }
  .platform_right .release .release_button {
    padding: 10px 0;
    border-bottom: 1px solid #999999;
  }
 .platform_right .release .release_button button {
    background: #ffffff;
    color: #e73262;
    border: #e73262 1px solid;
    border-radius: 8px;
    padding: 6px 9px;
    cursor: pointer;
  }
  .platform_right .release .release_button .active {
    background: #e73262;
    color: #ffffff;
  }
  .platform_right .release .release_button button+button {
    margin-left: 11px;
  }
  .platform_right .release .release_contnet p {
    margin-top: 13px;
    letter-spacing: 1px;
  }
.notice {
    /* 2 */
    margin-top: 29px;
  }
  .notice .notice_title {
    font-size: 15px;
    font-weight: bold;
    padding-left: 8px;
    border-left: 8px solid #e73262;
  }
  .notice .notice_content {
    padding-left: 22px;
    padding-bottom: 13px;
    border-bottom: 1px solid #777777;
    overflow: hidden;
  }
  .notice .notice_content p {
    padding: 15px 0 ;
    border-bottom: 1px dashed #777777;
    cursor: pointer;
  }
.explain {
  /* 3 */
  margin: 36px 0;
}
.explain .explain_content {
  margin-left: 19px;
}
.explain .explain_content p {
  margin-bottom: 23px;
}
.platform_right .release .release_contnet span{
	    color: #3273dc;
			margin-left: 0px;
}
</style>
